var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.419,
    height: 21.418,
    viewBox: "0 0 21.419 21.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ZoomIn",
    transform: "translate(-2846.829 -332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M113.414,35a8.414,8.414,0,1,0,8.414,8.414A8.418,8.418,0,0,0,113.414,35Zm0,1.53a6.884,6.884,0,1,1-6.884,6.884A6.888,6.888,0,0,1,113.414,36.53Z",
    transform: "translate(2741.829 297)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M455.268,386.314l4.59,4.59a.765.765,0,1,0,1.082-1.082l-4.59-4.59a.765.765,0,0,0-1.082,1.082Z",
    transform: "translate(2407.085 -37.709)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M193.265,211.53h7.649a.765.765,0,1,0,0-1.53h-7.649a.765.765,0,0,0,0,1.53Z",
    transform: "translate(2658.154 129.649)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M280,123.265v7.649a.765.765,0,0,0,1.53,0v-7.649a.765.765,0,1,0-1.53,0Z",
    transform: "translate(2574.479 213.325)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/ZoomIn.c0d13599b115345f52a96da83fdde950.svg";
export { ForwardRef as ReactComponent };